<template>
  <div>
    <!-- Breadcrumb -->
    <app-breadcrumb>
      <template #contentright>
        <span />
      </template>
    </app-breadcrumb>

    <!-- Filters -->
    <b-card no-body>
      <b-card-header class="pb-50">
        <h5>
          {{ $t('Filters') }}
        </h5>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col
            cols
            class="mb-md-0 mb-2"
          >
            <label>Người dùng</label>
            <v-select
              v-model="searchUserId"
              label="name"
              :filterable="false"
              :options="userOptions"
              @search="fetchUsers"
            >
              <template slot="no-options">
                tìm user...
              </template>
              <template
                slot="option"
                slot-scope="option"
              >
                <div class="d-center">
                  {{ option.username }} ({{ option.full_name }})
                </div>
              </template>
              <template
                slot="selected-option"
                slot-scope="option"
              >
                <div class="selected d-center">
                  {{ option.username }} ({{ option.full_name }})
                </div>
              </template>
            </v-select>

          </b-col>
          <b-col
            cols
            class="mb-md-0 mb-2"
          >
            <label>Tác vụ</label>
            <b-form-select
              v-model="action"
              @change="fetchLog"
            >
              <b-form-select-option
                v-for="option in actionOptions"
                :key="option.id"
                :value="option.id"
              >
                {{ option.name }}
              </b-form-select-option>
            </b-form-select>
          </b-col>
          <b-col
            cols
            class="mb-md-0 mb-2"
          >
            <label>Nguồn</label>
            <b-form-select
              v-model="source"
              @change="fetchLog"
            >
              <b-form-select-option
                v-for="option in sourceOptions"
                :key="option.id"
                :value="option.id"
              >
                {{ option.name }}
              </b-form-select-option>
            </b-form-select>
          </b-col>
          <b-col
            cols
            class="mb-md-0 mb-2"
          >
            <label>Trạng thái</label>
            <b-form-select
              v-model="code"
              @change="fetchLog"
            >
              <b-form-select-option
                v-for="option in codeOptions"
                :key="option.id"
                :value="option.id"
              >
                {{ option.name }}
              </b-form-select-option>
            </b-form-select>
          </b-col>
          <b-col
            cols
            class="mb-md-0 mb-2"
          >
            <label>Từ ngày</label>
            <b-input-group class="input-group-merge">
              <flat-pickr
                ref="startDateRef"
                v-model="startDate"
                class="form-control"
                :config="configDate"
              />
              <b-input-group-append is-text>
                <feather-icon
                  :icon="!startDate ? 'CalendarIcon' : 'XIcon'"
                  @click.prevent="!startDate ? $refs.startDateRef.$el.focus() : startDate = ''"
                />
              </b-input-group-append>
            </b-input-group>
          </b-col>

          <b-col
            cols
            class="mb-md-0 mb-2"
          >
            <label>Đến ngày</label>
            <b-input-group class="input-group-merge">
              <flat-pickr
                ref="endDateRef"
                v-model="endDate"
                class="form-control"
                :config="configDate"
              />
              <b-input-group-append is-text>
                <feather-icon
                  :icon="!endDate ? 'CalendarIcon' : 'XIcon'"
                  @click.prevent="!endDate ? $refs.endDateRef.$el.focus() : endDate = ''"
                />
              </b-input-group-append>
            </b-input-group>
          </b-col>

          <b-col
            cols
            class="mb-md-0 mb-2"
          >
            <label>Tìm kiếm</label>
            <b-input-group>
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block"
                placeholder="tên file"
                @keyup.enter="fetchLog"
              />
              <b-input-group-append>
                <b-button
                  variant="primary"
                  @click="fetchLog"
                >
                  <feather-icon icon="SearchIcon" />
                </b-button>
              </b-input-group-append>
            </b-input-group>

          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <!-- Table Container Card -->
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card
        no-body
        class="mb-0"
      >

        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <!-- Per Page -->
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>{{ $t('Show') }}</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              />
              <label>{{ $t('entries') }}</label>
            </b-col>

            <!-- Search -->
            <b-col
              cols="12"
              md="6"
            >
              <div class="d-flex align-items-center justify-content-end" />
            </b-col>
          </b-row>
        </div>

        <b-table
          ref="refListTable"
          class="position-relative"
          :items="itemsData"
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          responsive
          show-empty
          empty-text="Không tìm thấy kết quả"
          :sort-desc.sync="isSortDirDesc"
        >

          <!-- Column: user_id -->
          <template #cell(user)="row">
            <b-link class="font-weight-bold d-block text-nowrap">
              {{ row.item.user.full_name }}
            </b-link>
            <small class="text-muted">@{{ row.item.user.username }}</small>
          </template>

          <template #cell(file_original)="row">
            {{ $t(row.item.file_original) }}
          </template>
          <template #cell(message)="row">
            {{ row.item.message }}
          </template>
          <template #cell(source)="row">
            {{ resolveSourceText(row.item.source) }}
          </template>
          <template #cell(action)="row">
            {{ resolveActionText(row.item.action) }}
          </template>
          <template #cell(code)="row">
            <b-badge :variant="`light-${resolveCodeVariant(row.item.code)}`">
              {{ resolveCodeText(row.item.code) }}
            </b-badge>
          </template>
          <template #cell(progress)="row">
            <b-badge :variant="`light-primary`">
              {{ row.item.progress }}%
            </b-badge>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{ $t('show_to_entries', { from: dataMeta.from, to: dataMeta.to, of: dataMeta.of }) }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                v-model="currentPage"
                :total-rows="totalEntries"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BOverlay, BCard, BCardHeader, BCardBody, BRow, BCol, BFormInput, BButton, BTable, BInputGroup, BInputGroupAppend,
  BPagination, BLink, BFormSelect, BFormSelectOption, BBadge,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import {
  ref, computed, watch, getCurrentInstance,
} from '@vue/composition-api'
// import { showToast } from '@/@core/utils/utils'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import store from '@/store'
import useFileManager from '../files/useFileManager';

export default {
  components: {
    AppBreadcrumb,
    BOverlay,
    BCard,
    BCardHeader,
    BCardBody,
    BRow,
    BCol,
    BButton,
    BTable,
    BLink,
    BBadge,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BFormSelect,
    BFormSelectOption,
    BPagination,
    flatPickr,
    vSelect,
  },

  setup(props, context) {
    // Table Handlers
    const tableColumns = [
      { key: 'user', sortable: false, thAttr: { width: '150' } },
      {
        key: 'file_original', sortable: false, label: 'File',
      },
      {
        key: 'code', sortable: false, label: 'Trạng thái', thAttr: { width: '100' },
      },
      {
        key: 'message', sortable: false, label: 'Thông tin', thAttr: { width: '250' },
      },
      {
        key: 'progress', sortable: false, label: '% tải', thAttr: { width: '150' },
      },
      {
        key: 'source', sortable: false, label: 'Nguồn', thAttr: { width: '150' },
      },
      {
        key: 'action', sortable: false, label: 'Loại', thAttr: { width: '150' },
      },
      {
        key: 'updated_at', sortable: false, label: 'Lúc', thAttr: { width: '150' },
      },
    ];
    const loading = ref(false);
    const perPage = ref(10);
    const totalEntries = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const searchUserId = ref(0);
    const source = ref('');
    const code = ref('');
    const action = ref('');
    const searchQuery = ref('');
    const sortBy = ref('id');
    const isSortDirDesc = ref(true);
    const isPaginate = ref(1);
    const itemsData = ref([]);
    const startDate = ref(null);
    const endDate = ref(null);
    const refListTable = ref(null);
    const moduleOptions = ref([]);
    const userOptions = ref([]);
    const actionOptions = ref([
      // { id: '', name: 'Không xác định' },
      { id: 1, name: 'Tải lên' },
      { id: 2, name: 'Lấy về' },
    ]);

    const codeOptions = ref([
      // { id: '', name: 'Không xác định' },
      { id: 1, name: 'Thành công' },
      { id: 2, name: 'Lỗi' },
    ]);
    const sourceOptions = ref([
      // { id: '', name: 'Không xác định' },
      { id: 1, name: 'Mam' },
      { id: 2, name: 'Dalet' },
      { id: 3, name: 'Mam, Dalet' },
    ]);
    const { configDate } = useFileManager();

    const vm = getCurrentInstance();

    const resolveSourceText = (id) => {
      const item = sourceOptions.value.find((x) => x.id === id);
      return item ? item.name : '';
    }
    const resolveActionText = (id) => {
      const item = actionOptions.value.find((x) => x.id === id);
      return item ? item.name : '';
    }
    const resolveCodeText = (id) => {
      const item = codeOptions.value.find((x) => x.id === id);
      return item ? item.name : '';
    }
    const resolveCodeVariant = (a) => (a === 1 ? 'success' : 'danger')

    const fetchLog = () => {
      loading.value = true;
      store.dispatch('logs/fetchFileLog', {
        user_id: searchUserId.value ? searchUserId.value.id : '',
        start_date: startDate.value,
        end_date: endDate.value,
        perPage: perPage.value,
        page: currentPage.value,
        isPaginate: isPaginate.value,
        source: source.value,
        action: action.value,
        code: code.value,
        keyword: searchQuery.value,
        isOwner: context.root.$can('log.list_all_auth_log', 'Log') ? 0 : 1,
      })
        .then((response) => {
          loading.value = false;
          if (response.status === 200) {
            if (response.data.code === 200) {
              const items = response.data.data;
              const { total } = response.data;
              totalEntries.value = total;
              itemsData.value = items;
            }
          }
        });
    };

    const fetchUsers = (search, fetchLoading) => {
      if (search.length) {
        fetchLoading(true);
        store.dispatch('users/searchUser', { keyword: search })
          .then((res) => {
            if (res.status === 200) {
              userOptions.value = res.data.data;
            } else {
              userOptions.value = [];
            }
            fetchLoading(false)
          })
      }
    };

    watch([currentPage, perPage, startDate, endDate, action, source, code], () => {
      fetchLog();
    });
    const dataMeta = computed(() => {
      const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0;
      return {
        from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: totalEntries.value,
      };
    });

    fetchLog();

    return {
      startDate,
      endDate,
      dataMeta,
      loading,
      tableColumns,
      perPage,
      currentPage,
      totalEntries,
      perPageOptions,
      searchUserId,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      itemsData,
      userOptions,
      fetchLog,
      fetchUsers,
      resolveCodeVariant,
      resolveSourceText,
      resolveActionText,
      resolveCodeText,
      source,
      code,
      action,
      moduleOptions,
      actionOptions,
      sourceOptions,
      codeOptions,
      configDate,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
